export function getUrlFromPath(urlPath?: string) {
  const baseUrl = window.location.origin || 'https://iwoca.co.uk';

  return urlPath ? `${baseUrl}${urlPath}` : null;
}
